module.exports = __webpack_public_path__ + "static/media/ADDVA_TOURAU.dec880d1.svg";